import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

const TeacherCard = ({teacher}) => {
    const goToProfile = () => {
        window.open(`${window.location.origin}/teacherpublicprofile/${teacher.user}`, '_blank')
    }

    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <div className="row align-items-center">
                        <div className="col-auto">
                            {teacher?.image != 'none' ? (
                                <LinkContainer to='' className=" avatar-xl ">
                                    <img 
                                        alt="Image placeholder" 
                                        className='teacherImage'
                                        src={`https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/profiles/${teacher?.image}`}
                                    />
                                </LinkContainer>
                            ) : (
                                <LinkContainer to='' className="avatar avatar-xl ">
                                    <img 
                                        alt="Image placeholder" 
                                        className='teacherImage'
                                        src={`../../assets/img/10542486.png`}
                                    />
                                </LinkContainer>
                            )}
                        </div>
                        <div class="col  teacherInfo">
                            <LinkContainer to=''>                    
                                <h5 className="mb-0 text-center " >
                                <span className='tittleColo41' style={{textTransform: 'capitalize'}}>{teacher.firstname} {teacher.lastname}</span>
                                </h5>
                            </LinkContainer>
                            <p className="text-sm text-muted mb-0 text-center" style={{textTransform: 'capitalize'}}>
                                {teacher.jobtitle}</p><br />
                            <p className="mt-0 mb-0 text-sm text-center">
                            <LinkContainer to=''onClick={goToProfile} className='btn btn-default'>
                                <Button variant='primary  bg-gradient-primary border border-0 rounded-pill'> &nbsp; Go to Profile &nbsp;</Button>
                            </LinkContainer>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TeacherCard
